<div class="container" >
  <div class="logout-header w-full">
    <h2>Logout</h2>
  </div>
  <hr class="custom-hr">
  <div class="logout-detail w-full flex">
    <p class="logout-message">Are you sure want to logout?</p>
    <div class="logout-actions flex w-full">
      <p class="cancel-logout pointer" (click)="dontLogout()">Cancel</p>
      <button class="button outline-warn-button flex w-full" (click)="logOut()">
        <img src="assets/images/icons/logout-red.svg" alt="Logout Icon">
        <span>Logout</span>
      </button>
    </div>
  </div>
</div>